export default __webpack_public_path__ + "static/media/hht1_ep08_timeline_q01_a.ec294f6c.png";